import { render } from "./kanbanp_popup.vue?vue&type=template&id=19f4518d"
import script from "./kanbanp_popup.vue?vue&type=script&lang=js"
export * from "./kanbanp_popup.vue?vue&type=script&lang=js"

import "./kanbanp_popup.vue?vue&type=style&index=0&id=19f4518d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__